<template>
    <nav class="navbar navbar-expand-lg navbar-red">
        <div class="container-fluid">
            <button
                class="navbar-toggler navbar-burger"
                type="button"
                @click="toggleSidebar"
                :aria-expanded="$sidebar.showSidebar"
                aria-label="Toggle navigation"
            >
                <span class="navbar-toggler-bar"></span>
                <span class="navbar-toggler-bar"></span>
                <span class="navbar-toggler-bar"></span>
            </button>
            <p class="text-white mt-3 px-4 text-uppercase">{{ asf.name }}</p>
            
            <div  v-if="showIfRoleIs('asf-admin') && isCertified()">
              <button
                  class="btn btn-default"
                  type="button"     
                  v-if="checkExpiryDate()"  
                  @click="downloadCertified"               
                >
                <i class="fas fa-download"></i>
                Baixar Certificado
              </button>
              <button
                    class="btn"
                    style="cursor: default"
                    disabled
                    type="button"
                    v-else
                >
                  <i class="fas fa-download"></i>
                  Certificado expirado
                </button>
            </div>            

            <div class="collapse navbar-collapse">
                <ul class="navbar-nav ml-auto">
                    <li style="width: 400px;" v-if="asf.length > 0">
                        <multiselect
                            v-model="asf_value"
                            :options="asfs"
                            :custom-label="asfLabel"
                            placeholder="Select one"
                            label="name"
                            track-by="id"
                            @open="getAsfs"
                        ></multiselect>
                    </li>
                    <li class="nav-item">
                        <a href class="nav-link" @click.prevent="logout">
                            <i class="fas fa-sign-out-alt"></i>{{ $t("top_menu.logout") }}
                        </a>
                    </li>
                    <li class="nav-item">
                      <locale-changer></locale-changer>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>
<script>
import { mapState } from "vuex";
import LocaleChanger from "./LocaleChanger.vue";
import { saveAs } from 'file-saver';

export default {
  components :{
    LocaleChanger
  },
  computed: {
    ...mapState("asfs", {
      asfs: "all"
    }),
    asf() {
      return this.$store.getters["auth/getAsf"];
    }
  },
  data() {
    return {
      asf_value: "",
      activeNotifications: false
    };
  },
  watch: {
    asf_value: function(newData) {
      if (newData instanceof Object) {
        this.$store.dispatch("resetAll");
        let newAsf = newData.id;
        if (newData.super_asf) {
          newAsf = null;
        }
        this.$store.commit("auth/setCurrentAsf", newAsf);
        this.$router.push({ name: "dashboard" });
      }
    }
  },
  methods: {
    checkExpiryDate(){
      
      let asf = this.$store.getters['auth/getAsf'];
  
      let valid = true;
      let initial = new Date(asf.initial_date);
      let end = new Date(asf.expiry_date);
      let now = Date.now();
      
      if ( new Date(now) < initial || new Date(now) > end ) {
        valid = false;
      }

      return valid;
    },
    isAdmin() {
      return this.$store.getters["auth/getIsAdmin"];
    },
    isCertified() {
      let certified = this.$store.getters['auth/getAsf'].certified ;
      return (certified == null || !certified) ? 0 : 1;
    },
    downloadCertified(){            
      let pdf = this.$store.dispatch("asfs/downloadCertified", this.$store.getters['auth/getAsf'].id);
    },
    asfLabel({ name, vat }) {
      return `${name} — ${vat}`;
    },
    getAsfs() {
      this.$store.dispatch("asfs/getAllAsfs");
    },
    customersLabel({ name, document }) {
      return `${name} — ${document}`;
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    showIfRoleIs(role) {
      return this.$store.getters["auth/isInRoles"](role);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    logout() {
      this.$router.push({ name: "logout" });
    }
  }
};
</script>
<style>
</style>
